export const PropertyForms = {
  GetDeviceQRCode: 'getDeviceQRCode',
};
